import React, { useEffect, useState } from "react";
import Button from "@ingka/button";
import OrderSearchView from "./orderSearchView";
import DeliveryAndServiceView from "./deliveryAndServiceView";
import OrderDetailView from "./orderDetailView";
import OrderActionsView from "./orderActionsView";
import Container from "../components/layout/Container";
import { useDispatch, useSelector } from "react-redux";
import { loadOrderActions, loadOrderDetails, processOrderAction } from "../store/orderCorrectionService/thunks";
import * as actionCreators from "../store/orderCorrectionService/actions";
import ArticlesDetailsView from "./articlesDetailsView";
import Toast from "@ingka/toast";
import Loading, { LoadingBall } from "@ingka/loading";

import styled from "styled-components";
import ErrorDialog from "./modelPopup/errorDialog";

const OrderCorrectionView = privilegeCountries => {
	const dispatch = useDispatch();
	const Separator = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  border-top 5px solid #DFDFDF;
  margin: 30px;
  margin-right: 10px;
  margin-bottom: 10px;
  max-width: ${props => props.maxwidth};
`;

	const { orderActions, selectedAction, orderDetails, processingOrder, orderNumber, columnConfigurations, articleColumnConfigurations, selectedSearchCountry } = useSelector(
		state => state.orderCorrectionController
	);
	const [isLoading, setisLoading] = useState(false);
	const [showValidationError, setShowValidationError] = useState(false);
	const orderDetailsLoading = orderDetails.length === 0 || (orderDetails.length === 1 && orderDetails[0].isEmptyLine);
	const errorDetails = orderDetails.find(pOrderDetail => pOrderDetail.errorFlag);
	useEffect(() => {
		if (orderActions.length === 0 && privilegeCountries.searchCountries.length === 1 && selectedSearchCountry.code !== null && selectedSearchCountry.code !== "") {
			dispatch(loadOrderActions(selectedSearchCountry.code));
		}
	}, [orderActions.length, selectedSearchCountry, privilegeCountries, dispatch]);

	function processAction({ target }) {
		if (orderDetails.some(orderDetail => orderDetail.isCashOnFulfilmentOrder)) {
			setShowValidationError(true);
		} else if (orderDetails.some(orderDetail => orderDetail.isSelected)) {
			dispatch(actionCreators.setProcessingOrder({ isProcessingOrder: true, message: "" }));
			dispatch(processOrderAction());
			dispatch(actionCreators.setSelectedAction({ value: "", isDummy: true }));
			dispatch(actionCreators.setSelectedService(orderDetails.find(pOrderDetail => pOrderDetail.isSelected).rowId, false));
		}
	}

	function handleSearch(event) {
		setisLoading(true);
		const regex = /^[0-9\b]{9,10}$/;
		const orderNoValid = regex.test(orderNumber);

		if (orderNoValid && !selectedSearchCountry.isDummy) {
			dispatch(actionCreators.setSelectedAction({ value: "", isDummy: true }));
			dispatch(actionCreators.setProcessingOrder({ isProcessingOrder: false, message: "" }));
			dispatch(actionCreators.clearOrderDetails());
			dispatch(loadOrderDetails(orderNumber, selectedSearchCountry.code));
		}
	}

	function shouldShowArticleView() {
		return (
			orderDetails &&
			orderDetails.length > 0 &&
			orderDetails.any(detail => !detail.isDummy && detail.isSelected) &&
			!selectedAction.isDummy &&
			selectedAction.value === "ISELL_Article_Cancellation_ISOM_UC9"
		);
	}

	const isProcessActionDisabled = () => {
		if (selectedAction && !selectedAction.isDummy && orderDetails.filter(orderDetail => orderDetail.isSelected).length > 0) {
			let isArticleCancellation = selectedAction.value === "ISELL_Article_Cancellation_ISOM_UC9";
			if (isArticleCancellation) {
				const selectedService = orderDetails.find(pOrderDetail => pOrderDetail.isSelected);
				const selectedArticles = selectedService.connectedArticles.where(article => article.isSelected).toArray();
				if (selectedArticles.length === 0) {
					return true;
				}
			}
			return false;
		} else {
			return true;
		}
	};

	return (
		<>
			<OrderSearchView
				onChange={({ target }) => {
					const regex = /^[0-9\b]+$/;
					if (target.value === "" || regex.test(target.value)) {
						dispatch(actionCreators.setOrderNumber(target.value));
					}
				}}
				onSearch={handleSearch}
				onClearSearch={() => {
					dispatch(actionCreators.setOrderNumber(""));
				}}
				value={orderNumber}
				selectedCountry={selectedSearchCountry}
				onSearchCountryChange={country => {
					if (selectedSearchCountry.code === "" || (country.code === "CN" && selectedSearchCountry.code !== "CN") || (country.code !== "CN" && selectedSearchCountry.code === "CN")) {
						dispatch(loadOrderActions(country.code));
					}
					dispatch(actionCreators.setSearchCountry(country));
				}}
				availableCountries={privilegeCountries.searchCountries}
			/>
			{isLoading && orderDetails[0].isEmptyLine && (
				<div
					style={{
						background: "rgb(var(--colour-neutral-1, #ffffff))",
						padding: "20px"
					}}
				>
					<Loading text="Searching for order">
						<LoadingBall color="emphasised" size="large" />
					</Loading>
				</div>
			)}
			{!orderDetailsLoading && !errorDetails && (
				<>
					<Separator maxwidth={"90%"}></Separator>

					{orderDetails && orderDetails.length > 0 && <OrderDetailView orderDetails={Array.from([orderDetails[0]])} columnConfigurations={columnConfigurations.orderInfo} />}

					{orderDetails && orderDetails.length > 0 && (
						<DeliveryAndServiceView
							orderDetails={orderDetails}
							columnConfigurations={columnConfigurations.deliveryAndServicesInfo}
							onSelectionChange={({ target }) => {
								dispatch(actionCreators.setSelectedService(target.id, target.checked));
							}}
						/>
					)}
					{orderDetails && orderDetails.length > 0 && (
						<OrderActionsView
							onChange={data => {
								//console.log(data);
								dispatch(actionCreators.setSelectedAction(data));
							}}
							selectedAction={selectedAction.value}
							orderActions={orderActions}
						/>
					)}
					<Container justifyContent={"flex-start"} margintop={"20px"} marginleft={"30px"} maxwidth={"250px"}>
						<Button type="primary" fluid={true} onClick={processAction} disabled={isProcessActionDisabled()} text="Process Action"></Button>
					</Container>

					{shouldShowArticleView() && (
						<ArticlesDetailsView
							articleDetails={orderDetails.find(detail => detail.isSelected) !== undefined ? orderDetails.find(detail => detail.isSelected).connectedArticles : []}
							columnConfigurations={articleColumnConfigurations}
							onSelectionChange={({ target }) => {
								dispatch(actionCreators.setSelectedArticle(target.id, target.checked));
							}}
						/>
					)}

					{processingOrder && processingOrder.isProcessingOrder && processingOrder.message && processingOrder.message.length > 0 && (
						<Toast
							style={{ top: "calc(env(safe-area-inset-top, 0) + 4em)" }}
							text={processingOrder.message}
							isOpen={processingOrder.isProcessingOrder}
							onCloseRequest={() => {
								dispatch(actionCreators.setProcessingOrder({ isProcessingOrder: false, message: "" }));
							}}
							ariaLabelCloseBtn="Dismiss notification"
						/>
					)}
				</>
			)}
			{errorDetails && <ErrorDialog errorTitle={errorDetails.errorTitle} errorDescription={errorDetails.errorDescription} buttonText="Okay" />}
			{showValidationError && (
				<ErrorDialog
					errorTitle="Unable to process 'Cash On Fulfilment' orders"
					errorDescription="Orders using 'Cash On Fulfilment' as the payment method cannot be processed. Please create an incident in SupportMe to close this order."
					buttonText="Okay"
					setShowValidationError={setShowValidationError}
				/>
			)}
		</>
	);
};

export default OrderCorrectionView;
